import { useState } from "react";
import { LOGO_SLUGS } from "./logoManifest";

const initials = (name) =>
  name
    .replace(/A\.Ş\.?/gi, "")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

// Logolar yerelden (public/logos/{slug}.png) sunulur; yoksa baş-harf nişanı.
export const BrokerLogo = ({ slug, name, className = "", size = 64 }) => {
  const hasLogo = slug && LOGO_SLUGS.has(slug);
  const [broken, setBroken] = useState(!hasLogo);

  if (!broken) {
    return (
      <img
        src={`/logos/${slug}.png`}
        alt={`${name} logo`}
        loading="lazy"
        onError={() => setBroken(true)}
        className={`shrink-0 rounded-sm bg-white object-contain p-1.5 ring-1 ring-hair ${className}`}
        style={{ width: size, height: size }}
        data-testid="broker-logo-img"
      />
    );
  }

  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-sm bg-tint font-display font-semibold text-ink ring-1 ring-hair ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.3 }}
      data-testid="broker-logo-fallback"
    >
      {initials(name)}
    </div>
  );
};
